// extracted by mini-css-extract-plugin
export default {"mainPage":"MainPage_mainPage__vUwMh"};